import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface Props {
  open: boolean;
  message: string;
  onClose: (e: any) => void;
}

export const DialogConfirmation: FunctionComponent<Props> = ({
  open,
  message,
  onClose,
}) => {
  const handleClose = (confirmation: boolean) => {
    onClose(confirmation);
  };
  const { t } = useTranslation();

  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth="xs"
        style={{ userSelect: 'none' }}
        PaperProps={{ sx: { backgroundColor: 'var(--app-dialog-background)', width: '100%' } }}
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {t('confirmWindowTitle')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => handleClose(false)}>
            {t('cancel')}
          </Button>
          <Button style={{ color: 'red' }} onClick={() => handleClose(true)}>
            {t('delete')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
